import gql from 'graphql-tag';
import { apolloClient } from '@lon/mathnation-suit/configs';

export const client = apolloClient;

export const query = gql`
  query MyQuery($responseIds: [String!], $studentIds: [String!]) {
    notes(input: { responseIds: $responseIds, studentIds: $studentIds }) {
      items {
        data
        id
        studentId
        type
      }
    }
  }
`;

